import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
} from '@chakra-ui/react';
import { AutoEndWarning } from '~/common/api/zeiterfassungServerApi/AutoEndWarningApi';
import EmployeeApi from '~/common/api/zeiterfassungServerApi/EmployeeApi';
import DateApi from '~/common/api/zeiterfassungServerApi/DateApi';
import { Text } from '~/common/components/defaultUIComponents';
import { formatName } from '~/common/utils/employeeUtils';
import { useWarningContext } from './WarningContext';
import useTranslate from '~/common/utils/translate';
import { Paper } from '~/common/components/Paper';
import { useAutoEndWarnings } from './utils';
import { format } from 'date-fns';
import React from 'react';

export const Warnings = () => {
  const t = useTranslate();
  const { openEmployee, date, close } = useWarningContext();
  const [{ data: employees }] = EmployeeApi.hooks.useEmployeeQuery();
  const employee = React.useMemo(
    () => employees?.find((e) => parseInt(e.id) === openEmployee),
    [openEmployee, employees],
  );
  const warnings = useAutoEndWarnings(date, employee);
  return (
    <Drawer isOpen={!!openEmployee} onClose={close} placement="right">
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>{t('warnings.of', [formatName(employee)])}</DrawerHeader>
        <DrawerBody>
          {warnings.map((warning) => (
            <WarningBox key={warning.id} warning={warning} />
          ))}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

const WarningBox = ({ warning }: { warning: AutoEndWarning }) => {
  const { data: date } = DateApi.hooks.useGetDate(
    { id: warning.date },
    { enabled: !!warning },
  );
  const dateStr = React.useMemo(() => {
    if (!date) {
      return 'Unkown.';
    }
    return format(new Date(date?.date as unknown as number), 'dd.MM.yy');
  }, [date]);
  return (
    <Paper>
      <Text params={[dateStr]}>warnings.autoended</Text>
    </Paper>
  );
};
